export const environment = {
  env: process.env.NEXT_PUBLIC_ENV,
  appUrl: process.env.NEXT_PUBLIC_APP_URL,
  sendbirdAppId: process.env.NEXT_PUBLIC_SENDBIRD_APP_ID,
  contactEmail: 'info@creatorland.com',
  supportEmail: 'support@creatorland.com',
  apiUrl: process.env.NEXT_PUBLIC_API_HOST,
  googleAnalytics: process.env.NEXT_PUBLIC_GOOGLE_ANALYTICS,
  sentryDns: process.env.SENTRY_DSN,
  sentryPublicDns: process.env.NEXT_PUBLIC_SENTRY_DSN,
  externalTermsUrl:
    'https://www.notion.so/creatorland/Terms-Conditions-Creators-ff3ffe5e7399490aae398f72ff0cfaee',
  auth0ClientId: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID_V2,
  auth0Domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN_V2,
  auth0RedirectUri: process.env.NEXT_PUBLIC_AUTH0_BASE_URL,
  auth0Audience: process.env.NEXT_PUBLIC_AUTH0_AUDIENCE_V2,
  analyticsUrl: process.env.NEXT_PUBLIC_ANALYTICS_URL,
  googleMapsApiKey: process.env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY,
  heapProjectId: process.env.NEXT_PUBLIC_HEAP_PROJECT_ID,
  stripePublishableKey: process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY,
  stripeSecretKey: process.env.STRIPE_SECRET_KEY,
  stripeProductInsiderLifetime: process.env.STRIPE_PRODUCT_INSIDER_LIFETIME,
  stripeProductInsiderMonthly: process.env.STRIPE_PRODUCT_INSIDER_MONTHLY,
  stripeProductInsiderYearly: process.env.STRIPE_PRODUCT_INSIDER_YEARLY,
  stripeProductInsiderProMonthly:
    process.env.STRIPE_PRODUCT_INSIDER_PRO_MONTHLY,
  stripeProductInsiderProYearly: process.env.STRIPE_PRODUCT_INSIDER_PRO_YEARLY,
  stripeCouponInsiderMonthly: process.env.STRIPE_COUPON_INSIDER_MONTHLY,
  stripeCouponInsiderYearly: process.env.STRIPE_COUPON_INSIDER_YEARLY,
}
